import React from "react";
import { connect } from "react-redux";
import { getNewFacilityList, changeRequestStatus, } from '../../services/employee/action';
import { deletePracticeRequested } from '../../services/admin/action';
import Model from '../common/model'
import Pagination  from '../common/pagination';
import DeleteModel from '../common/Model/deleteModel';
class NewFacilityList extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            facilityList : [],
            openPopUp:false,
            doctorName:"",
            facilityName:"",
            address:"",
            address2:"",
            city:"",
            state:"",
            zip:"",
            email:"",
            officeEmail:"",
            mobile:"",
            fax:"",
            model_text:"",
            modelConfirm:false,
            requestStatus:"",
            id:"",
            confirmPopUp: false,
            pageOfItems : [],
            requestId:"",
            openPopUpDel:false,

        }
    }

    

    
    fullView = (request) => {
        
       let doctorName = request.doctorName ? request.doctorName : "" ; 
       let facilityName = request.facilityName ? request.facilityName : "" ; 
       let address = request.address ? request.address : "" ; 
       let address2 = request.address2 ? request.address2 : "" ; 
       let city = request.city ? request.city : "" ; 
       let state = request.state ? request.state : "" ; 
       let zip = request.zip ? request.zip : "" ; 
       let email = request.email ? request.email : "" ; 
       let officeEmail = request.officeEmail ? request.officeEmail : "" ; 
       let mobile = request.mobile ? request.mobile : "" ; 
       let fax = request.fax ? request.fax : "" ; 
 

        this.setState({
            doctorName,
            facilityName,
            address,
            address2,
            city,
            state,
            zip,
            email,
            officeEmail,
            mobile,
            fax,
        },()=>{
          //  document.body.classList.add('modal-open');

            this.setState({
                openPopUp:true
            })
        })
    }
    closePop = () =>{
      //  document.body.classList.remove('modal-open');

        this.setState({
            confirmPopUp : false
        })
      }

      confirmOkay = (status, id) =>{
        this.setState({
         modelConfirm : true,
         confirmPopUp:false
        },()=>{
          if(this.state.modelConfirm){

            let payLoad = {
                "id":id,
                "requestStatus" :status
            }
            let access_token = this.props.loginDetails;
            
          
           
            this.props.changeRequestStatus(access_token, payLoad, );
          }
        })
      }
      
    changeStatus = (e, id) =>{
        let value = e.target.value
       // document.body.classList.add('modal-open');

        this.setState({
            confirmPopUp : true,
            model_text : "You want to Change status as "+value,
            requestStatus: value,
             id : id,
          })
         
        // const confirm = window.confirm("You want to Change status as " + value)
 
        // if(confirm){
        //     let payLoad = {
        //         "id":id,
        //         "requestStatus" :value
        //     }
        //     let access_token = this.props.loginDetails;
            
        //     let token = {
        //         access_token
        //     }
         //     this.props.changeRequestStatus(payLoad, token);
        // }
            
    }
   
    
    componentDidMount() {


        let access_token = this.props.loginDetails;
 
       
        this.props.getNewFacilityList(access_token);

    }

    onChangePage = (pageOfItems) => {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
    }

    openPopDel = (id) => {
      //  document.body.classList.add('modal-open');
        this.setState({
            openPopUpDel: true,
            requestId: id,
        })
      
    }
    closePopDel = () => {
        this.setState({
            openPopUpDel: false
        })
    }
    deleteNewPractice = (id) => {
         this.setState({
            openPopUpDel: false
        })

        let access_token = this.props.loginDetails;
         this.props.deletePracticeRequested(access_token, id, );
    }


    componentWillReceiveProps = nextProps =>{
        if(nextProps.getNewFacilityListStatus){
            let facilityList = nextProps.getNewFacilityListData.facilityRequestObj;
            this.setState({
                facilityList 
            })
        }else{
            this.setState({
                facilityList :[]
            })
        }
    }

    closePopUpModal = () => {

      //  document.body.classList.remove('modal-open');

        this.setState({
            openPopUp : false
        })
    }


    render(){

        const {
            doctorName,
            facilityName,
            address,
            address2,
            city,
            state,
            zip,
            email,
            officeEmail,
            mobile,
            fax,
             
        } = this.state
         let hrefValue = "#"
        return(
          <>
 	
            
                      <div className="bodyContent">
                          
                          <div className="row">
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <div className="titleBg">
                                        <h4>Requested Practice</h4>
                                    </div>
                                  <div className="table-responsive">
                                   <table className="table commonTable">
                                       <thead> 
                                         <tr>
                                             <th>Practice</th>
                                             <th>Doctor</th>
                                            <th>Location</th>
                                             <th>View</th>
                                             <th>Action</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                {this.state.pageOfItems.length > 0 ?
                                 this.state.pageOfItems.map((request, id ) =>{
                                     return(
                                        <tr key={id}>
 
                                          <td>{request.facilityName ?request.facilityName:"Not Provided "} </td>
                                          <td>{request.doctorName} </td>
                                          <td>{request.state}</td>
                                           <td><a href={hrefValue}  onClick={()=>{this.fullView(request)}} className="icon" title="Download"><i className="fa fa-eye" aria-hidden="true"></i></a></td>
                                          <td>
                                          <a href={hrefValue} className="icon" onClick={() => this.openPopDel(request.facilityRequestId)} title="Delete">
                                                        <i className="fa fa-trash" aria-hidden="true"></i>
                                                    </a>
                                          </td>
                                          
                                
                                         
                                         </tr>
                                     )
                                 }) :<tr style={{background:"transparent"}}><td colspan="6"><img alt="" src="images/no-record-found.png" width="180px" style={{opacity:"0.6"}}/></td></tr>
     
                                        
                                }   
                                
                                      </tbody>
                                   </table>
                                </div>
                               
 
   <Pagination items={this.state.facilityList}   onChangePage={this.onChangePage} />

                              </div>
                             
                          </div>
                          </div>

                {this.state.openPopUp &&
                    <div className="creatTasks">
                        <div className="modal fade in " id="createtask" role="dialog">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">New Practice Request Details</h4>
                                        <button type="button" className="close" onClick={this.closePopUpModal} >&times;</button>
                                    </div>

                                    <div className="modal-body">

                                        <div className="createtaskbody ">
                                            <div className="bgdefet">
                                                <div className="row">
                                                    <div className="form">
                                                         <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>DoctorName</label>
                                                                <span>{doctorName}</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>PracticeName</label>
                                                                <span>{facilityName}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>OfficeEmail</label>
                                                                <span>{officeEmail}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>OfficeFax</label>
                                                                <span>{fax}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>Email</label>
                                                                <span>{email}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>Mobile</label>
                                                                <span>{mobile}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>Address</label>
                                                                <span>{address}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>Address2</label>
                                                                <span>{address2}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>City</label>
                                                                <span>{city}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>State</label>
                                                                <span>{state}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>Zip</label>
                                                                <span>{zip}</span>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                         


                                        </div>
                                        <div className="bgdefet">
                                            <div className="modal-footer1">
                                                <button type="button" onClick={this.closePopUpModal} className="btngeo clearbtn">Close</button>
                                                {/* <button type="button"  onClick={()=>{this.setState({openPopUp:false})}} className="btngeo submitbtn clr448aff" data-dismiss="modal">Submit</button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }         
                 <Model text={this.state.model_text} status={this.state.confirmPopUp} closePop={this.closePop} confirmOkay={(e)=>this.confirmOkay( this.state.requestStatus, this.state.id) }/>
                 <DeleteModel header = "Delete" text="Are you sure you want to delete?" page="deleteNewPractice" status={this.state.openPopUpDel} confirmOkay={() =>this.deleteNewPractice(this.state.requestId)} closePop={this.closePopDel}/>

                     
              </>
        )
    }
}

 
const mapStateToProps = state => ({
    loginDetails: state.commonReducer.loginDetails,
    profileDetails: state.commonReducer.profileDetails,
    getNewFacilityListData : state.employeeReducer.getNewFacilityListData,
    getNewFacilityListStatus : state.employeeReducer.getNewFacilityListStatus,
    facilityList: state.employeeReducer.getNewFacilityListData,
});

const mapDispatchToProps = dispatch => ({
    getNewFacilityList : token => dispatch(getNewFacilityList(token)),
    changeRequestStatus : (token, Payload, ) => dispatch(changeRequestStatus(token, Payload, )),
    deletePracticeRequested : (token,id) => dispatch(deletePracticeRequested(token,id))

});

export default connect(
   mapStateToProps,
   mapDispatchToProps
)(NewFacilityList); 